import React from 'react';
interface SparklineProps {
  points: number[];
  positive: boolean;
  className?: string;
}
export function Sparkline({
  points,
  positive,
  className = ''
}: SparklineProps) {
  const width = 72;
  const height = 24;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;
  const path = points.map((value, index) => {
    const x = index / (points.length - 1) * width;
    const y = height - (value - min) / span * (height - 4) - 2;
    return `${index === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)}`;
  }).join(' ');
  return <svg viewBox={`0 0 ${width} ${height}`} className={`h-6 w-[72px] ${className}`} aria-hidden="true" focusable="false" data-id="element-32" data-mp="1n6cq0khfpmmk">
      <path d={path} fill="none" stroke={positive ? '#20C997' : '#FF4D4D'} strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" data-id="element-33" data-mp="1rzfo95x5pk93" />
    </svg>;
}